import { makeApiUrl, makeHttpClient } from '../../http';
import { ListTeleShifts as UsecaseRemoteListTeleShifts } from '~/domain/usecases/shifts/remote';
import { RemoteListTeleShifts } from '~/data/repository/shifts';

export const makeRemoteListTeleShifts = (): UsecaseRemoteListTeleShifts =>
  new RemoteListTeleShifts(
    makeApiUrl('/shifts/list'),
    makeHttpClient()
  );
